import { noop } from '../../../../utils/constants';
import Translator from '../../../../utils/translation/Translator';
import { Table } from '@idm/ui-components';

import React, { Component } from 'react';
import Skeleton from 'react-loading-skeleton';
import PropTypes from 'prop-types';

const switchClientDictionary = new Translator('ACCOUNT_SETTINGS.SWITCH_CLIENT');

class SearchResult extends Component {
  static propTypes = {
    currentPageData: PropTypes.arrayOf(PropTypes.object.isRequired),
    currentPageNumber: PropTypes.number,
    pageSize: PropTypes.number,
    searchResultsSize: PropTypes.number,
    isWaitingForResults: PropTypes.bool.isRequired,
    onClickRow: PropTypes.func.isRequired,
    onPageChange: PropTypes.func,
    searchError: PropTypes.bool,
    selectedRow: PropTypes.object.isRequired,
    dictionary: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  };

  static defaultProps = {
    currentPageNumber: 1,
    pageSize: 5,
    currentPageData: [],
    onPageChange: noop,
    searchResultsSize: 5,
    searchError: false,
  };

  static uniqueKeyMap = {
    addClient: 'addClient',
  };

  static recordUrlMap = {
    clientSwicth: 'addClient',
  };

  handlePageNumberChange = ({ numberOfPageJump }) => {
    const { currentPageNumber, onPageChange } = this.props;

    onPageChange(currentPageNumber + numberOfPageJump);
  };

  searchResultsSkeletonColumn = [
    {
      dataIndex: 'key',
      render: (key) => {
        return (
          <div key={key} className="table-skeleton">
            <Skeleton width="100%" height={30} />
          </div>
        );
      },
    },
  ];

  attachKeys = (data) => data.map((datum, index) => ({ key: `${index}`, ...datum }));

  render() {
    const {
      currentPageData,
      pageSize,
      currentPageNumber,
      isWaitingForResults,
      searchResultsSize,
      searchError,
      selectedRow,
      dictionary,
    } = this.props;

    const columnsValues = isWaitingForResults
      ? this.searchResultsSkeletonColumn
      : [
          {
            title: switchClientDictionary.get('COLUMN_CLIENT_NAME', dictionary),
            dataIndex: 'name',
            width: 250,
          },
          {
            title: switchClientDictionary.get('COLUMN_CLIENT_ID', dictionary),
            dataIndex: '_id',
            width: 250,
          },
          {
            title: switchClientDictionary.get('COLUMN_PURPOSE', dictionary),
            dataIndex: 'purpose',
            width: 30,
          },
        ];

    const skeletonTableData = this.attachKeys(new Array(pageSize).fill({}));

    const tableData = currentPageData.map((datum, index) => ({
      key: `${index}`,
      ...datum,
    }));

    const { onClickRow } = this.props;

    const resultsText = isWaitingForResults
      ? switchClientDictionary.get('LOADING', dictionary)
      : switchClientDictionary.get('NO_RESULTS', dictionary);

    const textDisplay = searchError
      ? switchClientDictionary.get('SEARCH_ERROR', dictionary)
      : resultsText;

    return (
      <section className="search-results">
        <Table
          emptyText={textDisplay}
          columns={columnsValues}
          data={isWaitingForResults && !searchError ? skeletonTableData : tableData}
          pageSize={pageSize}
          currentPageNumber={currentPageNumber}
          supportIdmPaginationModel={true}
          onPageNumberChange={this.handlePageNumberChange}
          isPreviousPageAvailable={currentPageNumber > 1 && !isWaitingForResults}
          isNextPageAvailable={
            pageSize * currentPageNumber < searchResultsSize && !isWaitingForResults
          }
          onClickRow={onClickRow}
          className="fixed-navigator .icc-table"
          supportRowSelection={tableData.length > 0}
          selectedRowKeys={selectedRow ? [selectedRow.key] : []}
          rowSelectionType="radio"
        />
      </section>
    );
  }
}
export default SearchResult;
